<table class="fondo_rischi">
  <tr class="selected_second_level">
    <td>Rischio di soccombenza</td>
    <td></td>
  </tr>
  <tr class="borded">
    <td>Grado di rischio</td>
    <td>{{sezione?.petitum?.gradoRischio?.label}}</td>
  </tr>
  <tr class="borded last">
    <td>% di soccombenza</td>
    <td>{{sezione?.petitum.percentualeSoccombenza ? sezione?.petitum.percentualeSoccombenza.toString().replace('.', ',')
      + " %" : ''}}</td>
  </tr>
</table>
<table class="fondo_rischi">
  <caption class="sr-only">Tabella fondo rischi</caption>
  <tr class="selected_second_level">
    <td>Fondo rischi</td>
    <td></td>
  </tr>
  <ng-template
    [ngIf]="!lastRevisioneFondoRischi?.importiTotali && lastRevisioneFondoRischi?.fondorischiControparti.length > 0">
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Importo</td>
      <td>{{sommaFondoRischiControparteAttr('sorte') | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Spese di giudizio</td>
      <td>{{sommaFondoRischiControparteAttr('speseGiudizio') | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded last">
      <td>Interessi legali</td>
      <td>{{sommaFondoRischiControparteAttr('interessi') | euro}} &euro;</td>
    </tr>
    <!--<tr *ngIf="isQuantificabile" class="borded last">
      <td>Rivalutazione</td>
      <td>{{sommaFondoRischiControparteAttr('rivalutazione') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>-->
    <!--<tr *ngIf="isQuantificabile" class="borded">
      <td>Previdenziali</td>
      <td>{{sommaFondoRischiControparteAttr('previdenziali') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Assistenziali</td>
      <td>{{sommaFondoRischiControparteAttr('assistenziali') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded last">
      <td>Tfr</td>
      <td>{{sommaFondoRischiControparteAttr('tfr')| percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>-->
  </ng-template>
  <ng-template [ngIf]="lastRevisioneFondoRischi?.importiTotali || lastRevisioneFondoRischi?.percentualeSoccombenza">
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Importo</td>
      <td>{{lastRevisioneFondoRischi.importoFR | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Spese di giudizio</td>
      <td>{{lastRevisioneFondoRischi.speseFR | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded last">
      <td>Interessi legali</td>
      <td>{{lastRevisioneFondoRischi.interesseFR | euro}} &euro;</td>
    </tr>
    <!--<tr *ngIf="isQuantificabile" class="borded last">
      <td>Rivalutazione</td>
      <td>{{sommaFondoRischiControparteAttr('rivalutazione') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>-->
    <!--<tr *ngIf="isQuantificabile" class="borded">
      <td>Previdenziali</td>
      <td>{{sommaFondoRischiControparteAttr('previdenziali') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded">
      <td>Assistenziali</td>
      <td>{{sommaFondoRischiControparteAttr('assistenziali') | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>
    <tr *ngIf="isQuantificabile" class="borded last">
      <td>Tfr</td>
      <td>{{sommaFondoRischiControparteAttr('tfr')| percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} &euro;</td>
    </tr>-->
  </ng-template>
  <tr class="selected_second_level">
    <td>Totale</td>
    <td *ngIf="!lastRevisioneFondoRischi?.importiTotali && lastRevisioneFondoRischi?.fondorischiControparti.length > 0">{{parseTotale(calcolaSomma([sommaFondoRischiControparteAttr('sorte'),
      sommaFondoRischiControparteAttr('speseGiudizio'),
      sommaFondoRischiControparteAttr('interessi'),
      sommaFondoRischiControparteAttr('rivalutazione')
      ]
      )) | percentage: (sezione?.petitum?.percentualeSoccombenza ? sezione?.petitum?.percentualeSoccombenza : 100) |
      euro
      }} &euro;
    </td>
    <td *ngIf="lastRevisioneFondoRischi?.importiTotali || lastRevisioneFondoRischi?.percentualeSoccombenza">
    	{{lastRevisioneFondoRischi.speseFR + lastRevisioneFondoRischi.importoFR + lastRevisioneFondoRischi.interesseFR | euro}}
    </td>
  </tr>
  <!--<tr class="selected_second_level">
    <td>Totale soccombenza</td>
    <td>{{parseTotale(calcolaSomma([sommaFondoRischiControparteAttr('sorte'),
            sommaFondoRischiControparteAttr('speseGiudizio'),
            sommaFondoRischiControparteAttr('interessi'),
            sommaFondoRischiControparteAttr('rivalutazione'),
            sommaFondoRischiControparteAttr('previdenziali'),
            sommaFondoRischiControparteAttr('assistenziali'),
            sommaFondoRischiControparteAttr('tfr')
        ]
    )) | percentage: sezione?.petitum?.percentualeSoccombenza
      }} &euro;
    </td>
  </tr>-->
</table>
<ng-template [ngIf]="!lastRevisioneFondoRischi?.importiTotali && lastRevisioneFondoRischi?.fondorischiControparti.length > 0">
  <p style="background-color: #f0f0f0; padding: 5px;">Lista ripartizione Fondo Rischi</p>

  <table class="table-striped table table-revisione-fondorischi">
    <caption class="sr-only">Tabella fondo rischi controparte</caption>
    <tr>
      <th>Parte</th>
      <!--<th>Società</th>-->
      <th>Importo</th>
      <th>Spese legali</th>
      <th>Interessi</th>
      <!--<th>Rivalutazione</th>-->
      <!--<th>Previdenziali</th>-->
      <!--<th>Assistenziali</th>
    <th>Tfr</th>-->
    </tr>
    <tr *ngFor="let fondorischioControparte of lastRevisioneFondoRischi?.fondorischiControparti">
      <td>{{fondorischioControparte.controparte?.parte?.nominativo}}</td>
      <!--<td>{{fondorischioControparte.societa?.descrizione}}</td>-->
      <td>{{approssimaImporto(fondorischioControparte.sorte) | percentage: (sezione?.petitum?.percentualeSoccombenza ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>
      <td>{{approssimaImporto(fondorischioControparte.speseGiudizio) | percentage:
        (sezione?.petitum?.percentualeSoccombenza ? sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>
      <td>{{approssimaImporto(fondorischioControparte.interessi)| percentage: (sezione?.petitum?.percentualeSoccombenza
        ?
        sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>
      <!--<td>{{approssimaImporto(fondorischioControparte.rivalutazione)| percentage:
      (sezione?.petitum?.percentualeSoccombenza ? sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>-->
      <!--<td>{{approssimaImporto(fondorischioControparte.previdenziali)| percentage:
      (sezione?.petitum?.percentualeSoccombenza ? sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>-->
      <!--<td>{{approssimaImporto(fondorischioControparte.assistenziali)| percentage:
      (sezione?.petitum?.percentualeSoccombenza ? sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>
    <td>{{approssimaImporto(fondorischioControparte.tfr)| percentage: (sezione?.petitum?.percentualeSoccombenza ?
      sezione?.petitum?.percentualeSoccombenza : 100) | euro}} €</td>-->
    </tr>
  </table>
</ng-template>